import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import useCurrentUser from "@/hooks/useCurrentUser";

interface HostCompanyGateProps {
  /** Rendered with the signed-in host's company id once it is known. */
  children: (companyId: string) => ReactNode;
}

/** Resolves the signed-in host's company, explaining what to do when they have none yet. */
function HostCompanyGate({ children }: HostCompanyGateProps) {
  const { t } = useTranslation();
  const { user, isLoading, error } = useCurrentUser();

  if (isLoading) {
    return <p>{t("host.loading")}</p>;
  }
  if (error || !user) {
    return <p role="alert">{t("host.loadError")}</p>;
  }
  if (!user.companyId) {
    return <p role="alert">{t("host.noCompany")}</p>;
  }

  return <>{children(user.companyId)}</>;
}

export default HostCompanyGate;
export type { HostCompanyGateProps };
